import { render } from "./VillaLogo.vue?vue&type=template&id=2a42aa60&scoped=true"
import script from "./VillaLogo.vue?vue&type=script&lang=js"
export * from "./VillaLogo.vue?vue&type=script&lang=js"

import "./VillaLogo.vue?vue&type=style&index=0&id=2a42aa60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a42aa60"]])

export default __exports__